import React from "react";
import styled from "styled-components";
import basketicon from "../Images/basketicon.svg";
import VTEXIcon from "../Images/VTEX-logo.png";
import Background from "../Images/Background.jpg";
import { useSession } from "../authentications/SessionContext";

const LayoutContainer = styled.div`
  width: 50%;
  height: 100vh;
  position: relative;

  .basketicon {
    position: absolute;
    left: 4%;
    top: 6%;
  }

  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const LeftHalf = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(${Background});
  background-size: cover;
  background-position: initial;
  background-repeat: no-repeat;

  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const LeftLayout = ({ children }) => {
  const { sessionInfo } = useSession();
  const { isVTEX } = sessionInfo;

  return (
    <LayoutContainer>
      <LeftHalf>
        <img
          className="basketicon"
          style={{ maxWidth: 200, objectFit: "contain" }}
          src={isVTEX ? VTEXIcon : basketicon}
          alt="ContactIcon"
        />
        {children}
      </LeftHalf>
    </LayoutContainer>
  );
};

export default LeftLayout;
